import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=a5f5cd54&scoped=true"
import script from "./PaymentList.vue?vue&type=script&lang=js"
export * from "./PaymentList.vue?vue&type=script&lang=js"
import style0 from "./PaymentList.vue?vue&type=style&index=0&id=a5f5cd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f5cd54",
  null
  
)

export default component.exports